import React from 'react';
import { Button, Form, Modal } from 'reactstrap';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";
import { resultStatus } from '../../../../constants/holcim';
import { BaseCustomModal, BaseCustomButton, GradientDecorationLine } from '../../../../shared';

export const PartialReportStatusModal = ({ props, setShowModal, showModal, modalRespInfo, isUpdate, requestStatus }) => {

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            deliveryResultStatus: requestStatus?.deliveryResultStatus ?? '-',
        },
        validationSchema: Yup.object({
            deliveryResultStatus: Yup.string().required("Seleccione un área de laboratorio"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
            // dispatch(loginUser(values, props.history));
        }
    });

    const { className } = props;
    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () =>{
        validation.resetForm()
    }

    const title = (
        <div className=' d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>Edición estatus de informe parcial</h4></label>
        </div>
    );

    const footerButtons = (
        <div className="page-title-box d-flex justify-content-end">
          <BaseCustomButton
            color="success"
            outline
            className="rounded-3 me-2"
            onClick={validation.handleSubmit}
            label="Guardar"
            icon="mdi mdi-content-save me-1"
          />
          <BaseCustomButton
            color="danger"
            outline
            className="rounded-3 me-3"
            onClick={toggle}
            label="Cancelar"
            icon="mdi mdi-close-circle-outline me-1"
          />
        </div>
    );

    return (
        <BaseCustomModal
          title={title}
          isModalOpen={showModal}
          handleCancel={toggle}
          handleOk={validation.handleSubmit} 
          className={className}
          footer={footerButtons}
          onClosed={onClosed} 
        >
          <GradientDecorationLine />
    
          <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-1 px-5">
              <label className="text-primary">Estatus Informe Parcial</label>
              <select
                disabled={isUpdate}
                required
                name="deliveryResultStatus"
                className="form-select text-primary"
                placeholder="Estatus"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.deliveryResultStatus || ""}
              >
                {resultStatus.map((dir, index) => (
                  <option key={index} value={dir.id}>
                    {dir.value}
                  </option>
                ))}
              </select>
            </div>
    
            <div className="mt-5">
              <GradientDecorationLine />
            </div>
          </Form>
        </BaseCustomModal>
      );
};